import { render, staticRenderFns } from "./UndoVariant.vue?vue&type=template&id=17925a1f"
import script from "./UndoVariant.vue?vue&type=script&lang=js"
export * from "./UndoVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports